import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import marketData from '../../data/marketData.json';

const Herosection = () => {
  const { hero } = marketData

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  const statVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (index) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, delay: index * 0.15 + 0.5 }
    })
  }

  return (
    <section id="hero-market" className="min-vh-100 hero-section-primary5 d-flex align-items-center justify-content-center position-relative">
      <Container className="py-5">
        <Row className="align-items-center justify-content-center g-4">
          <Col lg={10} xs={12}>
            <motion.div variants={cardVariants} initial="hidden" animate="visible">
              <Card className="border-0 shadow-sm rounded-4 bg-white bg-opacity-50">
                <Card.Body className="p-4 p-lg-5 text-center">
                  <motion.h2 className="display-5 fw-semibold mb-3"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                  >
                    {hero.title}
                  </motion.h2>
                  <motion.p className="lead text-secondary mb-4"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.5 }}
                  >
                    {hero.subtitle}
                  </motion.p>

                  <motion.div className="d-flex flex-wrap justify-content-center gap-2"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                  >
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button href="#contact-market" variant="success">Get a Research Plan</Button>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button href="/index.html#pricing" variant="outline-success">See Packages</Button>
                    </motion.div>
                  </motion.div>
                  <motion.p className="text-secondary mt-3 mb-0"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.5 }}
                  >
                    {hero.description}
                  </motion.p>

                  <Row className="g-2 mt-3">
                    {hero.stats.map((stat, index) => (
                      <Col xs={12} md={4} key={stat.id}>
                        <motion.div className="p-3 bg-white bg-opacity-75 rounded-3 shadow-sm h-100"
                          variants={statVariants}
                          initial="hidden"
                          animate="visible"
                          custom={index}
                          whileHover={{ y: -5, scale: 1.03, transition: { duration: 0.2 } }}
                        >
                          <div className="d-flex align-items-center justify-content-center mb-1">
                            <i className={`${stat.icon} text-success me-2`}></i>
                            <small className="text-secondary">{stat.label}</small>
                          </div>
                          <div className="fw-semibold text-primary">{stat.value}</div>
                        </motion.div>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Herosection;
